export default "__VITE_ASSET__Bz9yg9cB__"